<template>
  <div :style="{ padding: '0 0 32px 32px' }">
    <h4 :style="{ marginBottom: '20px' }">{{ title }}</h4>
    <div id="chart_example" style="width: auto;height:400px;">

    </div>
    <!--    <v-chart-->
    <!--      v-if="initData&&initData.length>1"-->
    <!--      height="254"-->
    <!--      :data="data"-->
    <!--      :forceFit="true"-->
    <!--      :extend="extend"-->
    <!--      :padding="['60', '60', '60', '60']">-->
    <!--      <v-tooltip />-->
    <!--      <v-axis :line="axis1Opts.line"/>-->
    <!--      <v-bar position="x*y"/>-->
    <!--    </v-chart>-->
    <!--    <div v-else>-->
    <!--      <a-empty >-->
    <!--&lt;!&ndash;        <span slot="description">暂无统计数据</span>&ndash;&gt;-->
    <!--      </a-empty>-->
    <!--    </div>-->
  </div>
</template>

<script>

const echarts = require('echarts')
const data = []
export default {
  name: 'Bar',
  props: {
    title: {
      type: String,
      default: ''
    },
    initData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      data,
      height: '',
      width: ''
    }
  },
  mounted() {
    if (document.getElementById('chart_example')) {
      this.height = document.getElementById('chart_example').offsetHeight
      this.width = document.getElementById('chart_example').offsetWidth
    }
    let xData, yData
    if (this.initData.length !== 0) {
      this.initData = this.initData.map(item => {
        item.x = item.tj_time
        item.y = item.tj_money * 1
        return item
      })
      xData = this.initData.map(item => {
        return item.x
      })
      yData = this.initData.map(item => {
        return item.y
      })
      this.data = this.initData
    } else {
      const date = new Date().getDate()
      const day = new Date().getDay()
      const year = new Date().getFullYear()
      console.log(year + '-' + day + '-' + date)
      xData = [year + '-' + day + '-' + date]
      yData = [0]
    }

    const myChart = echarts.init(document.getElementById('chart_example'))
    const option = {
      color: ['#83bff6'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: [
        {
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          type: 'category',
          data: xData,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed' // 设置网格线类型 dotted：虚线   solid:实线
            }
          }
        }
      ],
      series: [
        {
          name: '金额(元)',
          type: 'bar',
          barWidth: '60%',
          data: yData
        }
      ]
    }
    if (document.getElementById('chart_example')) {
      window.addEventListener('resize', function() { // 监听
        this.height = document.getElementById('chart_example').offsetHeight
        this.width = document.getElementById('chart_example').offsetWidth
        myChart.resize()
      })
    }
    myChart.setOption(option)
  }
}
</script>
